export default class ResetPasswordController {
  /* @ngInject */
  constructor($scope, ApiAuthentication, $state, localStorageService, $ionicPopup, $filter) {
    this.ApiAuthentication = ApiAuthentication;
    this.$state = $state;
    this.localStorageService = localStorageService;
    this.$ionicPopup = $ionicPopup;
    this.translate = $filter('translate');

    // Prerequisites
    this.user = {};
  }

  passwordForgotten() {
      const user = this.user;
      this.ApiAuthentication.initiatePasswordReset(user.email).then((res) => {
          if (res !== undefined) {
              var alertPopup = this.$ionicPopup.alert({
                  title: this.translate('CHECK_EMAIL'),
                  template: this.translate('RESET_PASSWORD_MSG')
              });
  
              alertPopup.then((res) => {
                  this.$state.go('login');
              });
          } 
      });
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/user/resetPassword.controller.js
 **/